import React, { useEffect, useMemo, useState } from "react";

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableFooter,
    TableSortLabel,
    Menu,
    Chip,
    Button,
    ImageListItem,
} from "@mui/material";
import { SlOptionsVertical } from "react-icons/sl";
import { Box, Checkbox, Grid, MenuItem, Typography } from "@mui/material";
import { AiOutlineEye } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import { BiSortAlt2 } from "react-icons/bi";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import { partnerOtpVerifyAction } from "../../../actions/partnerAction/partnerAction";
import { successTrueMsgAction } from "../../../actions/globalAction";
import { SUCCESS_TRUE_MSG_ERR } from "../../../constants/roleManagmentConstant";
import MenuBar from "../../customComponent/MenuBar";
import Dialogue from "../../customComponent/Dialogue";
import { applicationDeclarationApproveAction } from "../../../actions/aplicationActions/applicationsAction";
import TableNoItemComponent from "../../customComponent/TableNoItemComponent";
import PremissionDialog from "../../customComponent/premissionDialog";
import PartnerMenuBar from "../../customComponent/PartnerMenuBar";
import PartnerDialogue from "../../customComponent/PartnerDialogue";

function PartnerApplicationTable({
    setIdsFunction,
    data,
    columns,
    leadFindLoading,
    component,
    subMenu,
    pagiantionEntry,
    paginationPageNumber,
    viewedColumn,
    setSelectedLeadIds
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isApprovePrevilage } = usePrivilegeCheck();

    const [selectedRows, setSelectedRows] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [visible, setVisible] = useState(false);

    const { successAlertMsgSuccess, successAlertMsgErr } = useSelector(
        (state) => {
            return state.successTrueMsg;
        },
    );

    let { partnerDeleteSuccess } = useSelector((state) => {
        return state.deletePartner;
    });

    let { partnerOtpVerifySuccess, partnerOtpVerifyError } = useSelector(
        (state) => {
            return state.partnerOtpVerify;
        },
    );

    useEffect(() => {
        if (partnerDeleteSuccess && successAlertMsgSuccess) {
            Swal.fire("Good job!", `deleted successfully`, "success");
            dispatch(successTrueMsgAction(false));
        }
    }, [partnerDeleteSuccess]);

    useEffect(() => {
        if (partnerOtpVerifySuccess && successAlertMsgSuccess) {
            Swal.fire("Good job!", `OTP verified successfully`, "success");
            dispatch(successTrueMsgAction(false));
        }
    }, [partnerOtpVerifySuccess]);

    useEffect(() => {
        if (partnerOtpVerifyError && successAlertMsgErr) {
            Swal.fire(
                "something went wrong",
                `Error ${partnerOtpVerifyError}`,
                "rror",
            );
            dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
        }
    }, [partnerOtpVerifyError]);

    useEffect(() => {
        if (viewedColumn?.length > 0) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [viewedColumn]);

    // Create a function to handle selecting all rows:
    const handleSelectAllRows = () => { };

    // Create a function to handle selecting individual rows:
    const handleSelectRow = (rowId) => {
        setSelectedRows(prev => {
            const updated = prev.includes(rowId)
                ? prev.filter(id => id !== rowId)
                : [...prev, rowId];

            setSelectedLeadIds(updated);
            setIdsFunction(updated);
            return updated;
        });
    };

    // table action
    const [leadActionButtonShow, setLeadActionButtonShow] = useState(null);
    const [tableId, setTableId] = useState("");
    const [otps, setOTPs] = useState({});
    const [page, setPage] = useState(paginationPageNumber);
    const [rowsPerPage, setRowsPerPage] = useState(pagiantionEntry);

    const leadOpenActionButton = Boolean(leadActionButtonShow);

    const handleClickAction = (event, id) => {
        setLeadActionButtonShow(event.currentTarget);
        setTableId(id);
    };

    const handleCloseAction = () => {
        setLeadActionButtonShow(null);
    };

    const CustomSortIcon = ({ direction }) => {
        return direction === "asc" ? (
            <img
                src="/menuIcons/tableUpSort.png"
                className="administratCustomIcon"
                alt="gsl"
                style={{ padding: "15px" }}
            />
        ) : (
            <BiSortAlt2 className="LeadCustomIcon" />
        );
    };

    // Handle OTP submission for a specific index
    const handleOTPSubmit = (index) => {
        // Handle OTP submission logic here
        console.log("OTP submitted:", otps[index]);
        if (otps) {
            dispatch(partnerOtpVerifyAction(otps));
        }
    };

    // sorting table
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");

    const requestSort = (column) => {
        let newSortOrder = "asc";
        if (column === sortBy && sortOrder === "asc") {
            newSortOrder = "desc";
        }

        setSortBy(column);
        setSortOrder(newSortOrder);
    };

    let sortedData = useMemo(() => {
        if (sortBy && data) {
            const sortedItems = [...data].sort((a, b) => {
                if (sortOrder === "asc") {
                    return a[sortBy] < b[sortBy] ? -1 : 1;
                } else {
                    return a[sortBy] < b[sortBy] ? 1 : -1;
                }
            });

            return sortedItems;
        }

        return data;
    }, [data, sortBy, sortOrder]);

    // Change the application status
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogComponentName, setDialogComponentName] = useState("");
    const [appliedApplicationId, setAppliedApplicationId] = useState("");
    const [menuData, setMenuData] = useState();
    const [leadId, setLeadId] = useState();
    const [isLeadDuplicate, setIsLeadDuplicate] = useState(false);
    const [applicationCountry, setApplicationCountry] = useState("");
    const [universityHandlerName, setUniversityHandlerName] = useState("");
    const [applyMethod, setApplyMethod] = useState('');

    const [currentStatus, setCurrentStatus] = useState();

    const handleClickOpen = (event, appliedListId, status, applyMethod) => {
        setMenuData(appliedListId?.column7);
        setAppliedApplicationId(appliedListId.id);
        setLeadId(appliedListId.leadId);
        setOpen(true);
        setApplyMethod(applyMethod);
        setAnchorEl(event.currentTarget);
        setIsLeadDuplicate(appliedListId?.isDuplicate);
        setApplicationCountry(appliedListId.column2);
        setUniversityHandlerName(appliedListId?.universityHandlerName);
        setCurrentStatus(status);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpen(false);
        setOpenDialog(false);
    };

    const handleOpenDialog = (status, statusName) => {
        setDialogComponentName(statusName);
        setOpenDialog(true);
    };

    const handleDeclarationApprove = (id) => {
        dispatch(applicationDeclarationApproveAction(id));
        Swal.fire("approved!", "request has been approved.", "success");
    };

    //Row per table ::::::::::::::::::::::::::::

    useEffect(() => {
        setRowsPerPage(pagiantionEntry);
        setPage(paginationPageNumber);
    }, [data, paginationPageNumber, pagiantionEntry]);

    useEffect(() => {
        const maxPage = Math.ceil(data.length / pagiantionEntry);
        if (page > maxPage) {
            setPage(maxPage);
        }
    }, [data, pagiantionEntry, page]);

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} lg={12}>
                    {leadFindLoading ? (
                        <>
                            <Typography variant="h1">
                                <Skeleton animation={false} />
                            </Typography>

                            <Typography variant="h3">
                                <Skeleton animation="wave" />
                            </Typography>

                            <Skeleton animation={false} />
                            <Typography variant="h3">
                                <Skeleton animation="wave" />
                            </Typography>

                            <Skeleton animation={false} />
                            <Typography variant="h3">
                                <Skeleton animation="wave" />
                            </Typography>

                            <Skeleton animation={false} />
                            <Typography variant="h3">
                                <Skeleton animation="wave" />
                            </Typography>

                            <Skeleton animation={false} />
                        </>
                    ) : (
                        <>
                            {sortedData.length > 0 ? (
                                <div
                                    style={{
                                        overflowX: "scroll",
                                        border: "0px solid #ffff",
                                    }}
                                    className="scrollBar"
                                >
                                    <Table className="Partner">
                                        <TableHead>
                                            <TableRow className="PartnerCell">
                                                <TableCell
                                                    style={{
                                                        position: "sticky",
                                                        left: 0,
                                                        zIndex: 1,
                                                        padding: "1px",
                                                        border: "1px solid #ddd",
                                                        backgroundColor: "#fafafa",
                                                    }}
                                                >
                                                    <Checkbox
                                                        onChange={handleSelectAllRows}
                                                        style={{ color: "#f81b82" }}
                                                    />
                                                </TableCell>
                                                {columns?.map((column) => {
                                                    if (column.hidden) {
                                                        return null;
                                                    }
                                                    return (
                                                        <TableCell
                                                            key={column.field}
                                                            className="PartnerCell PartnerCommon"
                                                            style={{
                                                                padding: "0 16px",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            <TableSortLabel
                                                                className="PartnerHeaderText"
                                                                active={column === sortBy}
                                                                direction={sortOrder}
                                                                onClick={() => requestSort(column)}
                                                                IconComponent={
                                                                    column.field !== "action" && CustomSortIcon
                                                                }
                                                            >
                                                                {column.title}
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData.map((item, indx) => (
                                                <TableRow className="Partner" key={indx}>
                                                    <TableCell
                                                        style={{
                                                            position: "sticky",
                                                            left: 0,
                                                            zIndex: 1, // To ensure it's above other cells
                                                            backgroundColor: "white", // Adjust as needed
                                                            padding: "1px",
                                                            border: "1px solid #ddd",
                                                        }}
                                                    >
                                                        <Checkbox
                                                            checked={selectedRows.includes(item.id)}
                                                            onChange={() => handleSelectRow(item.id)}
                                                            style={{ color: "#f81b82" }}
                                                        />
                                                    </TableCell>
                                                    {(!visible || viewedColumn.includes("sl")) && (
                                                        <TableCell
                                                            style={{
                                                                padding: "0 16px",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {(paginationPageNumber - 1) * 10 + indx + 1}
                                                        </TableCell>
                                                    )}

                                                    <TableCell
                                                        style={{
                                                            padding: "0 16px",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {item?.column1}
                                                    </TableCell>

                                                    {item.passport &&
                                                        (!visible ||
                                                            viewedColumn.includes("passportNumber")) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.passport}
                                                            </TableCell>
                                                        )}

                                                    {item?.email &&
                                                        (!visible || viewedColumn.includes("Email")) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.email}
                                                            </TableCell>
                                                        )}

                                                    {item?.mobile &&
                                                        (!visible ||
                                                            viewedColumn.includes("Phone Number")) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.mobile}
                                                            </TableCell>
                                                        )}

                                                    {(!visible || viewedColumn.includes("country")) && (
                                                        <TableCell
                                                            style={{
                                                                padding: "0 16px",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {item.column2}
                                                        </TableCell>
                                                    )}

                                                    {(!visible || viewedColumn.includes("course")) && (
                                                        <TableCell
                                                            style={{
                                                                padding: "0 16px",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {item.column3}
                                                        </TableCell>
                                                    )}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["University", "partner"].includes(col),
                                                        )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column4}
                                                            </TableCell>
                                                        )}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["universityHandler", "partner Manager"].includes(
                                                                col,
                                                            ),
                                                        )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                    color:
                                                                        item.column5 === "Not Assigned" ? "red" : "",
                                                                }}
                                                            >
                                                                {item.column5}
                                                            </TableCell>
                                                        )}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            [
                                                                "intake",
                                                                "assigned staff",
                                                                "leadOwner",
                                                            ].includes(col),
                                                        )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column6}
                                                            </TableCell>
                                                        )}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["Application Started Date"].includes(col),
                                                        )) &&
                                                        component == "entrolled" && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column14}
                                                            </TableCell>
                                                        )}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["status", "intak", "counsilor"].includes(col),
                                                        )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column7}
                                                            </TableCell>
                                                        )}

                                                    {component !== "declarationApprove" &&
                                                        component !== "entrolled" &&
                                                        item.column8
                                                        ?
                                                        (!visible ||
                                                            viewedColumn.some((col) =>
                                                                ["statu", "Telecaller"].includes(col)
                                                            )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                            >
                                                                {item.column8}
                                                            </TableCell>
                                                        )
                                                        : ""}

                                                    {component !== "declarationApprove" &&
                                                        component !== "entrolled" &&
                                                        item.column9
                                                        ? (!visible ||
                                                            viewedColumn.some((col) =>
                                                                ["intakes"].includes(col),
                                                            )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column9}
                                                            </TableCell>
                                                        )
                                                        : ""}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["Application Started Date"].includes(col),
                                                        )) &&
                                                        (component !== "declarationApprove" &&
                                                            component !== "entrolled" &&
                                                            item.column14 ? (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column14}
                                                            </TableCell>
                                                        ) : (
                                                            ""
                                                        ))}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["statuss"].includes(col),
                                                        )) &&
                                                        (component !== "declarationApprove" &&
                                                            component !== "entrolled" &&
                                                            item.column10
                                                            ? (!visible ||
                                                                viewedColumn.some((col) =>
                                                                    ["statuss"].includes(col),
                                                                )) && (
                                                                <TableCell
                                                                    style={{
                                                                        padding: "0 16px",
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    <Chip
                                                                        sx={{
                                                                            height: "auto",
                                                                            borderRadius: "3px",
                                                                            backgroundColor: "#FF7A001A",
                                                                            color: "#FF7A00",
                                                                            "& .MuiChip-label": {
                                                                                display: "block",
                                                                                whiteSpace: "normal",
                                                                                fontSize: "14px",
                                                                                fontWeight: 400,
                                                                                width: "max-content",
                                                                            },
                                                                        }}
                                                                        label={item.column10}
                                                                    />
                                                                </TableCell>
                                                            )
                                                            : "")}

                                                    {component !== "declarationApprove" &&
                                                        component !== "entrolled" &&
                                                        item.column11
                                                        ? (!visible ||
                                                            viewedColumn.some((col) =>
                                                                ["deferralMonth"].includes(col),
                                                            )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column11 ? item.column11 : "-"}
                                                            </TableCell>
                                                        )
                                                        : ""}

                                                    {component !== "declarationApprove" &&
                                                        component !== "entrolled" &&
                                                        item.column12
                                                        ? (!visible ||
                                                            viewedColumn.some((col) =>
                                                                ["deferalYear"].includes(col),
                                                            )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column12 ? item.column12 : "-"}
                                                            </TableCell>
                                                        )
                                                        : null}
                                                    {component !== "declarationApprove" && item.column13
                                                        ? (!visible ||
                                                            viewedColumn.some((col) =>
                                                                ["Paymentstatus"].includes(col),
                                                            )) && (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {item.column13 ? item.column13 : "-"}
                                                            </TableCell>
                                                        )
                                                        : ""}
                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["declarationForm"].includes(col),
                                                        )) &&
                                                        (component == "declarationApprove" &&
                                                            component !== "entrolled" ? (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                <a
                                                                    href={item?.column8}
                                                                    style={{ paddingLeft: "30px" }}
                                                                    target="blank"
                                                                >
                                                                    <AiOutlineEye
                                                                        style={{
                                                                            fontSize: "lg",
                                                                            width: "20px",
                                                                            height: "19px",
                                                                        }}
                                                                    />
                                                                </a>
                                                            </TableCell>
                                                        ) : (
                                                            ""
                                                        ))}

                                                    {(!visible ||
                                                        viewedColumn.some((col) =>
                                                            ["action"].includes(col),
                                                        )) &&
                                                        (component == "declarationApprove" &&
                                                            component !== "entrolled" ? (
                                                            <TableCell
                                                                style={{
                                                                    padding: "0 16px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                <Button
                                                                    sx={{
                                                                        backgroundColor: "rgba(34, 130, 0, 1)",
                                                                        color: "white",
                                                                        width: "76px",
                                                                        height: "25px",
                                                                        fontWeight: 400,
                                                                        fontSize: "12px",
                                                                        mr: 2,
                                                                        "&:hover": {
                                                                            backgroundColor: "rgba(34, 110, 0, 0.5)",
                                                                        },
                                                                    }}
                                                                    onClick={() => {
                                                                        if (isApprovePrevilage(subMenu)) {
                                                                            handleDeclarationApprove(item.id);
                                                                        } else {
                                                                            setOpenAlert(true);
                                                                        }
                                                                    }}
                                                                >
                                                                    Approve
                                                                </Button>

                                                                <Button
                                                                    sx={{
                                                                        backgroundColor: "red",
                                                                        color: "white",
                                                                        width: "76px",
                                                                        height: "25px",
                                                                        fontWeight: 400,
                                                                        fontSize: "12px",
                                                                        mr: 2,
                                                                        "&:hover": {
                                                                            backgroundColor: "rgba(34, 110, 0, 0.5)",
                                                                        },
                                                                    }}
                                                                >
                                                                    reject
                                                                </Button>
                                                            </TableCell>
                                                        ) : (
                                                            ""
                                                        ))}

                                                    {/* Application status change table cell */}
                                                    {component == "partnerapplication" && (
                                                        <TableCell
                                                            sx={{
                                                                padding: "0 16px",
                                                                whiteSpace: "nowrap",
                                                                textAlign: "right",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "12px",
                                                                    color: "rgba(255, 122, 0, 1)",
                                                                }}
                                                            >
                                                                <ImageListItem
                                                                    id="demo-positioned-button"
                                                                    aria-controls={
                                                                        open ? "demo-positioned-menu" : undefined
                                                                    }
                                                                    aria-haspopup="true"
                                                                    aria-expanded={open ? "true" : undefined}
                                                                    onClick={(e) => {
                                                                        handleClickOpen(e, item, item.column7, item.applyMethod);
                                                                    }}
                                                                    style={{ display: "block" }}
                                                                >
                                                                    <svg
                                                                        width="16"
                                                                        height="17"
                                                                        viewBox="0 0 16 17"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M3.9849 1.16134C3.8117 1.16651 3.64731 1.23891 3.52656 1.36319L0.859897 4.0299C0.735717 4.15482 0.666016 4.32382 0.666016 4.49996C0.666016 4.6761 0.735717 4.84509 0.859897 4.97001L3.52656 7.63795C3.652 7.76293 3.8219 7.83304 3.99897 7.83288C4.17603 7.83272 4.3458 7.76231 4.47101 7.63711C4.59621 7.5119 4.66663 7.34212 4.66679 7.16505C4.66695 6.98798 4.59685 6.81804 4.47187 6.69261L2.94714 5.16794H13.3352V7.20957C13.3269 7.30179 13.3379 7.39475 13.3675 7.48247C13.3971 7.57019 13.4447 7.65074 13.5071 7.71908C13.5696 7.78741 13.6456 7.84199 13.7303 7.87932C13.8151 7.91666 13.9066 7.936 13.9992 7.936C14.0918 7.936 14.1834 7.91666 14.2681 7.87932C14.3528 7.84199 14.4288 7.78741 14.4913 7.71908C14.5538 7.65074 14.6013 7.57019 14.6309 7.48247C14.6605 7.39475 14.6716 7.30179 14.6633 7.20957V5.16794C14.6633 4.44081 14.0623 3.83328 13.3352 3.83328H2.94062L4.47187 2.30331C4.56745 2.20935 4.63249 2.08883 4.65852 1.95736C4.68454 1.82589 4.67034 1.68963 4.61777 1.56635C4.5652 1.44307 4.47669 1.33846 4.3638 1.26623C4.2509 1.194 4.11886 1.15741 3.9849 1.16134ZM11.9914 9.15878C11.8587 9.15906 11.7292 9.19893 11.6193 9.27327C11.5094 9.34761 11.4242 9.45304 11.3745 9.57608C11.3249 9.69912 11.3131 9.83416 11.3406 9.96394C11.3682 10.0937 11.4338 10.2123 11.5292 10.3046L13.0591 11.8359H2.66588V9.85275C2.66692 9.76389 2.65019 9.67576 2.61666 9.59346C2.58313 9.51116 2.53349 9.43638 2.47065 9.37354C2.40781 9.3107 2.33304 9.26105 2.25074 9.22752C2.16844 9.19399 2.08027 9.17727 1.9914 9.17831C1.81459 9.18038 1.64585 9.25259 1.52229 9.37908C1.39873 9.50557 1.33048 9.67594 1.33255 9.85275V11.8359C1.33255 12.563 1.93875 13.164 2.66588 13.164H13.0591L11.5292 14.6952C11.4628 14.7559 11.4095 14.8294 11.3723 14.9113C11.3351 14.9931 11.3149 15.0817 11.3128 15.1716C11.3107 15.2615 11.3268 15.3509 11.3602 15.4344C11.3935 15.5179 11.4435 15.5938 11.5069 15.6575C11.5704 15.7212 11.646 15.7715 11.7294 15.8052C11.8128 15.8389 11.9021 15.8553 11.992 15.8536C12.0819 15.8519 12.1705 15.8321 12.2525 15.7952C12.3346 15.7584 12.4083 15.7053 12.4693 15.6392L15.1359 12.9725C15.1982 12.9106 15.2476 12.8369 15.2813 12.7558C15.3151 12.6747 15.3324 12.5878 15.3324 12.4999C15.3324 12.4121 15.3151 12.3251 15.2813 12.244C15.2476 12.1629 15.1982 12.0892 15.1359 12.0273L12.4693 9.36062C12.4071 9.29676 12.3328 9.24596 12.2508 9.21129C12.1687 9.17663 12.0805 9.15878 11.9914 9.15878Z"
                                                                            fill="#141E3C"
                                                                        />
                                                                    </svg>
                                                                </ImageListItem>
                                                            </Box>
                                                        </TableCell>
                                                    )}

                                                    {component == "partnerapplication" && (
                                                        <TableCell
                                                            sx={{
                                                                padding: "0 16px",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            <a
                                                                href={`application/partnerapplicationDetails/${item.id}/${item.leadId}`}
                                                                style={{ paddingLeft: "30px" }}
                                                            >
                                                                <AiOutlineEye
                                                                    style={{
                                                                        fontSize: "lg",
                                                                        width: "20px",
                                                                        height: "19px",
                                                                    }}
                                                                />
                                                            </a>
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableFooter />
                                    </Table>
                                </div>
                            ) : (
                                <TableNoItemComponent />
                            )}
                        </>
                    )}
                </Grid>
            </Grid >
            {openDialog === true && (
                <PartnerDialogue
                    openTrue={openDialog}
                    handleClose={handleClose}
                    headerName={
                        dialogComponentName === "Interview Training"
                            ? "Choose Interviewer"
                            : dialogComponentName === "Submitted to the university"
                                ? "Choose University Handler"
                                : dialogComponentName === "Submitted for Visa"
                                    ? "Choose Visa Officer"
                                    : dialogComponentName === "Visa received"
                                        ? "Visa details"
                                        : dialogComponentName === "Visa Applied"
                                            ? "Visa Status"
                                            : dialogComponentName === "Offer Letter Received" ||
                                                dialogComponentName === "Unconditional Offer Letter" ||
                                                dialogComponentName === "Conditional Offer Letter"
                                                ? "Enter Details"
                                                : dialogComponentName === "Submitted Declaration"
                                                    ? "Upload Declaration form"
                                                    : dialogComponentName === "Declaration Completed"
                                                        ? "Upload Declaration form from student"
                                                        : dialogComponentName === "Deposit Paid"
                                                            ? "Enter Details"
                                                            : dialogComponentName === "Refund In Progress"
                                                                ? "Enter Refund amount"
                                                                : dialogComponentName === "Enrolled"
                                                                    ? "Enter visa received date"
                                                                    : dialogComponentName === "Enrollment"
                                                                        ? "Enter visa received enrollment"
                                                                        : ""
                    }
                    Dailogcomponent={
                        dialogComponentName === "Interview Training"
                            ? "Interviewer"
                            : dialogComponentName === "Submitted to the university"
                                ? "university handler"
                                : dialogComponentName === "Submitted for Visa"
                                    ? "visa officer"
                                    : dialogComponentName === "Visa received"
                                        ? "university ID"
                                        : dialogComponentName === "Visa Applied"
                                            ? "visaDetails"
                                            : dialogComponentName === "Offer Letter Received" ||
                                                dialogComponentName === "Unconditional Offer Letter" ||
                                                dialogComponentName === "Conditional Offer Letter"
                                                ? "Offer Letter Received"
                                                : dialogComponentName === "Unconditional Offer"
                                                    ? "Unconditional Offer"
                                                    : dialogComponentName === "Submitted Declaration"
                                                        ? "Declaraton"
                                                        : dialogComponentName === "Declaration Completed"
                                                            ? "declarationCompleted"
                                                            : dialogComponentName === "Deposit Paid"
                                                                ? "depositPaid"
                                                                : dialogComponentName === "Refund In Progress"
                                                                    ? "refundPopup"
                                                                    : dialogComponentName === "Enrolled"
                                                                        ? "entrolled"
                                                                        : dialogComponentName === "Enrollment"
                                                                            ? "enrollment"
                                                                            : ""
                    }
                    appliedApplicationId={appliedApplicationId}
                    applicationCountry={applicationCountry}
                    handler={universityHandlerName}
                    leadID={leadId}
                />
            )
            }
            {
                open === true && (
                    <PartnerMenuBar
                        openTrue={open}
                        handleClose={handleClose}
                        handleOpenDialog={handleOpenDialog}
                        appliedApplicationId={appliedApplicationId}
                        menuStatus={menuData}
                        leadId={leadId}
                        isLeadDuplicate={isLeadDuplicate}
                        currentStatus={currentStatus?.trim()}
                        applicationCountry={applicationCountry}
                        applyMethod={applyMethod}
                    />
                )
            }

            {
                openAlert && (
                    <PremissionDialog
                        openAlert={openAlert}
                        handleClose={() => setOpenAlert(false)}
                    />
                )
            }
        </>
    );
}

export default PartnerApplicationTable;
